export default __webpack_public_path__ + "static/media/h.a2583594.svg";